import { createGlobalStyle } from 'styled-components';
import { media } from './media';

const Buttons = createGlobalStyle`

    .btn {
        display: inline-block;
        padding: 9px 26px;
        font-weight: 500;
        font-size: 10px;
        line-height: 100%;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        border-radius: 15px;
        border: 1px solid;
    }

    .btn--main {
        background-color: var(--main);
        border-color: var(--main);
        &:hover, &:focus {
            opacity: 0.85;
        }
    }
    .btn--accent-1 {
        background-color: var(--accent-1);
        border-color: var(--accent-1);
        &:hover, &:focus {
            opacity: 0.85;
        }
    }
    .btn--accent-2 {
        background-color: var(--accent-2);
        border-color: var(--accent-2);
        &:hover, &:focus {
            opacity: 0.85;
        }
    }

    .btn--cta {
      background-color: var(--accent-1);
      border: 0;
      border-radius: 0;
      display: block;
      width: 100%;
      font-size: 14px;
      line-height: 120%;
      letter-spacing: 0.01em;
      text-transform: uppercase;
      svg {
        height: 14px;
        margin-left: 16px;
        width: auto;
      }
      &:hover {
        opacity: .8;
        svg {
          margin-left: 26px;
        }
      }
    }

    .btn--border--white {
        border-color: rgba(var(--white-rgb),0.3);
        &:hover, &:focus {
            border-color: var(--white);
            opacity: 1;
        }
    }

    .btn--border--none {
        border-color: transparent;
    }

    .wrapper--zh .btn--text {
      font-size: 13px;
    }
    .btn--text {
        display: inline-block;
        position: relative;
        overflow-x: hidden;
        padding: 4px 0 4px 0;
        font-weight: 500;
        font-size: 10px;
        line-height: 100%;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        &.btn--text--large {
            margin: 0 0 5px;
            padding: 0 0 2px 0;
            font-size: 14px;
            font-weight: normal;
            line-height: 120%;
            letter-spacing: 0.01em;
            text-transform: inherit;
        }
        svg {
            position: absolute;
            top: 1px;
            right: 4px;
            transition: all .15s linear;
        }
        path {
            fill: currentColor;
        }
        &::before {
            position: absolute;
            bottom: 0;
            left: 0;
            content: '';
            width: 100%;
            height: 1px;
            transform: translateX(calc(-100% - .1rem));
            background: currentColor;
            animation: .25s linear 0s line-out forwards;
        }
        &:hover, &:focus {
            background-position: top 2px right 2px;
            &::before {
                animation:.25s linear 0s line-in forwards
            }
            svg {
                right: 0;
            }
        }
    }
    .btn--text--left {
      padding-left: 24px;
      svg {
        right: auto;
        left: 0;
      }
      &:hover {
        svg {
          transform: translate(-2px, 0);
        }
      }
    }
    .wrapper--zh .btn--text--svg span {
      font-size: 13px;
    }
    .btn--text--svg {
        position: relative;
        padding-top: 9px;
        padding-right: 20px;
        svg {
            position: absolute;
            top: 14px;
            right: 4px;
            transition: all .15s linear;
        }
        path {
            fill: currentColor;
        }
        span {
            display: inline-block;
            position: relative;
            overflow-x: hidden;
            padding: 4px 0 4px 0;
            font-weight: 600;
            font-size: 10px;
            line-height: 100%;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            vertical-align: top;
            &::before {
                position: absolute;
                bottom: 0;
                left: 0;
                content: '';
                width: 100%;
                height: 1px;
                transform: translateX(calc(-100% - .1rem));
                background: currentColor;
                animation: .25s linear 0s line-out forwards;
            }
        }
        &:hover, &:focus {
            span {
                background-position: top 2px right 2px;
                &::before {
                    animation:.25s linear 0s line-in forwards
                }
            }
            svg {
                top: 13px;
                right: 3px;
            }
        }
    }

    @keyframes line-in{
        0%{transform:translate3d(-101%,0,0)}
        to{transform:translateZ(0)}
    }

    @keyframes line-out{
        0%{transform:translateZ(0)}
        to{transform:translate3d(101%,0,0)}
    }

    .wrapper--zh .btn--text--play,
    .wrapper--zh .btn--text--icon {
      font-size: 13px;
    }
    .btn--text--play,
    .btn--text--icon {
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 10px;
        line-height: 100%;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        span {
            display: flex;
            align-items: center;
            width: 18px;
            height: 18px;
            margin: 0 0 0 10px;
            &::before {
                position: absolute;
                content: '';
                width: 18px;
                height: 18px;
                border-radius: 100%;
                border: 1px solid currentColor;
                transition: all .15s linear;
            }
        }
        svg {
            margin: 0 0 0 7px;
        }
        path {
            fill: currentColor;
        }
        &:hover, &:focus {
            span {
                &::before {
                    transform: scale(1.1);
                }
            }
        }
    }
    .btn--text--icon {
      span {
        &::before {
          display: none;
        }
      }
      svg {
        transition: all 0.15s linear;
        margin: 0;
      }
      &:hover {
        svg {
          transform: translate(2px, -2px);
        }
      }
    }
    .wrapper--zh .btn--rounded {
      font-size: 13px;
    }
    .btn--rounded {
        display: inline-block;
        padding: 13px 33px;
        font-weight: 600;
        font-size: 10px;
        line-height: 100%;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        border-radius: 100px;
        border: 1px solid;
        &.btn--rounded--slim {
            padding: 8px 20px;
        }
        &.w-full {
            display: inline-block;
            width: 100%;
            text-align: center;
        }
    }

    .btn--bg {
        border: 0;
        &.btn--bg--white {
            --bg: var(--white);
            --bg-rgb: var(--white-rgb);
            --o: 0.95;
        }
        &.btn--bg--primary-dark {
            --bg: var(--primary-dark);
            --bg-rgb: var(--primary-dark-rgb);
            --o: 0.8;
        }
        &.btn--bg--primary {
            --bg: var(--primary);
            --bg-rgb: var(--primary-rgb);
            --o: 0.9;
        }
        &.btn--bg--secondary-dark {
            --bg: var(--secondary-dark);
            --bg-rgb: var(--secondary-dark-rgb);
            --o: 0.8;
        }
        &.btn--bg--secondary {
            --bg: var(--secondary);
            --bg-rgb: var(--secondary-rgb);
            --o: 0.9;
        }
        &.btn--bg--tertiary-dark {
            --bg: var(--tertiary-dark);
            --bg-rgb: var(--tertiary-dark-rgb);
            --o: 0.8;
        }
        &.btn--bg--tertiary {
            --bg: var(--tertiary);
            --bg-rgb: var(--tertiary-rgb);
            --o: 0.9;
        }
        &.btn--bg--grey-3 {
            --bg: var(--grey-3);
            --bg-rgb: var(--grey-3-rgb);
            --o: 0.6;
        }
        background-color: var(--bg);
        &:hover, &:focus {
            background-color: rgba(var(--bg-rgb),var(--o));
        }
    }

    .btn--bg.btn--bg--accent-1 {
      --bg: var(--accent-1);
      border: 0;
      &:hover, &:focus {
        background-color: var(--accent-1);
        opacity: .8;
      }
    }

    /*
    .btn--border {
        &.btn--border--primary-dark {
            --color: var(--primary-dark);
        }
        &.btn--border--primary {
            --color: var(--primary);
        }
        &.btn--border--secondary-dark {
            --color: var(--secondary-dark);
        }
        &.btn--border--secondary {
            --color: var(--secondary);
        }
        &.btn--border--tertiary-dark {
            --color: var(--tertiary-dark);
        }
        &.btn--border--tertiary {
            --color: var(--tertiary);
        }
        &.btn--border--grey-4 {
            --color: var(--grey-4);
        }
        background-color: transparent;
        border-color: var(--color);
        &:hover, &:focus {
            border-color: var(--white);
            &.btn--border--grey-4 {
                border-color: var(--grey-6);
            }
        }
    }
    */


    .btn--box {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        height: 50px;
        svg {
        width: 12px;
        }
        &:hover, &:focus {
            opacity: 0.9;
        }
    }
    .wrapper--zh .btn--slider {
      font-size: 13px;
    }
    .btn--slider {
        position: relative;
        display: flex;
        width: 100%;
        min-width: 280px;
        font-weight: 600;
        font-size: 10px;
        line-height: 100%;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        box-shadow: inset 0 0 0 1px var(--grey-4);
        border-radius: 50px;
        color: var(--grey-5);
        .btn--slider-1, .btn--slider-2 {
            position: relative;
            z-index: 1;
            padding: 8px 0;
            width: 50%;
            text-align: center;
            transition: all 0.15s linear;
        }
        .btn--slider-2 {
            color: var(--white);
        }
        &::after {
            position: absolute;
            content: '';
            top: 0;
            left: 50%;
            width: 50%;
            height: 100%;
            background: var(--grey-4);
            border-radius: 50px;
            border: 1px solid var(--grey-4);
            transition: all 0.15s linear;
        }
        &.delivery, &.delivery-fade {
            .btn--slider-1 {
                color: var(--white);
            }
            .btn--slider-2 {
                color: var(--grey-5);
            }
            &::after {
                left: -1px;
                background: var(--primary);
                border: 1px solid var(--primary);
            }
        }
        &.secondary {
            &.delivery, &.delivery-fade {
                &::after {
                    background: var(--secondary);
                    border: 1px solid var(--secondary);
                }
            }
        }
    }

    .btn--circle {
        align-items: center;
        justify-content: center;
        width: 54px;
        height: 54px;
        border-radius: 100%;
        background-color: var(--grey-1);
        box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.11);
        &:hover, &:focus {
            background-color: var(--white);
        }
    }

    .btn--compare {
        width: 140px;
        text-align: center;
        a {
            display: block;
            margin-bottom: 10px;
            width: 100%;
        }
        .btn--bg.btn--bg--primary {
            border: 1px solid var(--primary);
        }
        .btn--bg.btn--bg--secondary {
            border: 1px solid var(--secondary);
        }
        &.brick {
            .btn--bg.btn--bg--primary,
            .btn--bg.btn--bg--secondary {
                background: transparent;
                border: 1px solid var(--grey-4);
                color: var(--grey-5);
            }
            .btn--border.btn--border--grey-4 {
                background: var(--grey-4);
                border-color: var(--grey-4);
                color: var(--white);
            }
        }
    }
    .btn--compare--title {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        font-weight: 500;
        font-size: 16px;
        line-height: 125%;
        letter-spacing: 0.01em;
        svg {
            margin: 0 0 0 8px;
            vertical-align: middle;
        }
    }
    .wrapper--zh .btn--compare--small {
      font-size: 13px;
    }
    .btn--compare--small {
        margin-bottom: 20px;
        font-size: 10px;
        line-height: 145%;
        letter-spacing: 0.04em;
    }

    .btn--arrow--angle {
        display: block;
        position: relative;
        width: 100%;
        &.btn--arrow--angle--large {
            font-size: 20px;
            line-height: 110%;
            letter-spacing: -0.01em;
            @media ${media.mdUp} {
                font-size: 24px;
            }
        }
        &:hover {
            svg {
                transform: translate(5px, -5px);
            }
        }
        span.small {
            display: block;
            margin: 2px 0 0;
        }
        svg {
            position: absolute;
            bottom: 5px;
            right: 0;
            transition: all .15s linear;
        }
        .h6 {
            display: inline-block;
            text-transform: lowercase;
            &:first-letter {
                text-transform: uppercase;
            }
        }
    }

    .btn--card {
        width: 220px;
        @media ${media.lgUp} {
            margin: 0 18px;
        }
        &.btn--card--large {
            width: 100%;
            margin: 0;
            .btn--card--image {
                width: 100%;
                height: 100%;
            }
        }
    }
    .btn--card--image {
        width: 220px;
        height: 260px;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        &:hover, &:focus {
            .btn--card--bg {
                transform: scale(1.025);
            }
            .btn--card--play {
                background-color: var(--grey-1);
            }
        }

    }
    .btn--card--bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: cover;
        transition: all .3s linear;
    }
    .btn--card--play {
        position: absolute;
        display: flex;
        z-index: 1;
        right: 0;
        bottom: 0;
        width: 50px;
        height: 50px;
        background-color: var(--grey-2);
        align-items: center;
        justify-content: center;
        transition: all .3s linear;
    }

    .btn--play {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 85px;
        height: 85px;
        margin-left: -5px;
        border-radius: 100%;
        svg {
            position: relative;
            z-index: 10;
            margin: 0 0 0 4px;
        }
        path {
            fill: var(--white);
        }
        &::after {
            position: absolute;
            z-index: 1;
            content: '';
            width: 85px;
            height: 85px;
            border-radius: 100%;
            background: currentColor;
            transform: scale(0.95);
            transition: all .15s linear;
            transform-origin: center;
        }
        &:hover, &:focus {
            &::after {
                transform: scale(1);
            }
        }
    }

    .btn--play-small {
      height: 50px;
      width: 50px;
      &::after {
        height: 50px;
        width: 50px;
      }
      svg {
        width: 10px;
        height: auto;
      }
      path {
          fill: var(--black);
      }
    }

    .btn--chat {
        position: fixed;
        z-index: 10;
        bottom: 20px;
        right: 20px;
    }
`;

export default Buttons;
